import React from 'react';
import { headerItemsCollectionPropTypes } from './HeaderItemsCollectionPropTypes';
import { ICON_NAMES } from './components/HeaderItem/constants/iconNames';
import HeaderItem from './components/HeaderItem/HeaderItem';
import * as styles from './HeaderItemsCollection.module.scss';
const HeaderItemsCollection = ({
  items,
  expandAndFocusSearchBar
}) => {
  if (!items) {
    return null;
  }
  const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, items.map((item, index) => {
    const isSearchButton = item.type === 'search';
    const iconKey = item.iconName || item.type;
    const iconName = ICON_NAMES[iconKey] || item.iconName || null;
    return /*#__PURE__*/React.createElement(HeaderItem, Object.assign({}, item, {
      iconName: iconName
    }, isSearchButton && {
      expandAndFocusSearchBar
    }, {
      classname: `${styles.rooItem} ${styles[`rootItem${capitalize(item.type)}`]}`,
      key: index
    }));
  }));
};
export default HeaderItemsCollection;